import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./storefront.jsx";
import "./styles.css";

createRoot(document.getElementById("root")).render(<App />);

import "./fulfillment.css";
